import { useCallback, useState } from 'react'
import { Turnstile } from '@marsidev/react-turnstile'

const useBotPrevention = () => {
  const [turnstileToken, setTurnstileToken] = useState('')

  return {
    turnstileToken,
    Turnstile: useCallback(() => {
      return (
        <Turnstile
          siteKey={process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY}
          onSuccess={setTurnstileToken}
        />
      )
    }, [setTurnstileToken]),
  }
}

export default useBotPrevention
